import type { ResourceDictionary } from "Infrastructure/Translations/ResourceDictionary";
import translation from "zod-i18n-map/locales/cs/zod.json";

export const CzechResourcesDictionary: ResourceDictionary = {
  Common: {
    AppName: "ProjectTemplate",
    AppTitle: "BLogic Quest",
    Years: "{{count}} let",
    Years_one: "{{count}} rok",
    Years_two: "{{count}} roky",
    Years_few: "{{count}} roky",
    Years_other: "{{count}} let",
    YearsLabel: "let",
    YearsLabel_one: "rok",
    YearsLabel_few: "roky",
    YearsLabel_other: "let",
    Month: "měsíc",
    Months: "{{count}} měsíců",
    Months_one: "{{count}} měsíc",
    Months_two: "{{count}} měsíce",
    Months_few: "{{count}} měsíce",
    Months_other: "{{count}} měsíců",
    Continue: "Pokračovat",
    Step: "KROK {{actual}} Z {{count}}",
    TextCopied: "Text byl zkopírován do schránky.",
    Yes: "Ano",
    No: "Ne",
    Choose: "Vyberte",
    Download: "Stáhnout",
    Downloading: "Stahování",
    UnsupportedFileType: "Nepodporovaný typ souboru",
    Email: "E-mail",
    Password: "Heslo",
    ExampleLogin: "např. antonin.vomacka@email.cz",
    PiecesShort: "{{count, number}} ks",
    PiecesSuffix: "ks",
    Active: "Aktivní",
    Inactive: "Neaktivní",
    Actual: "Aktuální",
    Blocked: "Blokováno",
    Canceled: "Zrušeno",
    Cancel: "Zrušit",
    Close: "Zavřít",
    Confirm: "Potvrdit",
    Loading: "Načítání...",
    Ended: "Ukončeno",
    All: "Vše",
    AllStatuses: "Všechny stavy",
    PrivacyPolicyLink: "Zásadách zpracování osobních údajů.",
    Error:
      "Něco se pokazilo. Omlouváme se za komplikace. Zkuste to prosím znovu za chvíli.",
    Save_Uppercase: "ULOŽIT",
    Save: "Uložit",
    Reset: "RESET",
    WithTax: "s DPH",
    WithoutTax: "bez DPH",
    Edit: "Upravit",
    Back: "Zpět",
    Delete: "Smazat",
    PreviousStep: "Předchozí krok",
    SaveAndClose: "Uložit a zavřít",
    SaveSuccess: "Uložení proběhlo úspěšně.",
    CompanyNumber: "IČ",
    TaxNumber: "DIČ",
    PersonalNumber: "RČ",
    ProcessedByRepresentative: "Zpracoval{{gender}} {{name}}",
    SendByRepresentative: "Odeslal{{gender}} {{name}}",
    SignOut: "Odhlásit se",
    Dashboard: "Přehled",
    Players: "Hráči",
    Quests: "Mise",
    Quest: "Mise",
    Challenges: "Výzvy",
    Challenge: "Výzva",
    Rewards: "Odměny",
    Reward: "Odměna",
    Requests: "Žádosti",
    Leaderboard: "Leaderboard",
    Profile: "Profil",
    CreateNew: "Vytvořit",
    ChooseDate: "Vybrat datum",
    Or: "Nebo",
    LimitedQuantity: "Omezené množství",
    ClaimReward: "Vybrat odměnu",
    UserNotFound: "Uživatel nenalezen",
    ErrorLoadingUserData: "Chyba při načítání uživatelských dat",
    Points: "{{count}} BLC",
    PointsLabel: "BLC",
    Need: "Potřeba",
    MorePoints: "více BLC",
    XP: "{{amount}} XP",
  },
  Auth: {
    SignInTitle: "Vítejte v BLogic Quest",
    SignInSubtitle: "Prosím přihlaste se pomocí svého BLogic e-mailu",
    SignInWithGoogle: "Přihlásit se přes Google",
  },
  Errors: {
    ApplicationError: {
      Title: "Nastala chyba",
      Home: "Domů",
    },
    Error404: {
      Subtitle: "Stránka nebyla nalezena",
      Home: "Domů",
    },
    Error403: {
      Subtitle: "K zobrazení této stránky nemáte přístupová práva",
    },
    Error500: "Při zpracování požadavku nastala chyba.",
  },
  Validation: {
    Required: "Toto pole je povinné.",
    Positive: "Hodnota musí být větší než nula.",
    MaxLength: "Překročena maximální délka.",
    NoWhitespaceOnly: "Pole nesmí obsahovat pouze mezery.",
    PickAtLeastOne: "Musíte si vybrat alespoň jednu odměnu.",
    DateRange: "Datum ukončení nemůže být před datem začátku.",
  },
  Pages: {
    CreateQuest: {
      Title: "Vytvořit misi",
      SubmitText: "Vytvořit",
      SuccessText: "Mise byla úspěšně vytvořena!",
      Error: "Chyba při vytváření Questu!",
      Fields: {
        Title: {
          Label: "Název",
        },
        Reward: {
          Label: "Odměna",
          Suffix: "BLC",
        },
        Type: {
          Label: "Kategorie",
          Types: {
            BugHunter: "Bug Hunter",
            Engineering: "Engineering",
            Mentoring: "Mentoring",
          },
        },
        Dates: {
          StartLabel: "Začátek",
          ExpirationLabel: "Ukončení",
        },
        Description: {
          Label: "Popis",
        },
        MaxParticipants: {
          Label: "Max. účastníků",
        },
      },
    },
    EditQuest: {
      Title: "Upravení mise",
      SubmitText: "Upravit",
      SuccessText: "Změny byly úspěšně uloženy!",
      Error: "Chyba při upravování Questu!",
      Fields: {
        Title: {
          Label: "Název",
        },
        Reward: {
          Label: "Odměna",
          Suffix: "BLC",
        },
        Description: {
          Label: "Popis",
        },
      },
    },
    DetailQuest: {
      Title: "Detail mise",
      Fields: {
        Name: "Název",
        Type: "Kategorie",
        Reward: "Odměna",
        Active: "Aktivní",
        Completed: "Splněno",
        Created: "Vytvořeno",
        Start: "Začátek",
        Expiration: "Ukončení",
        MaxParticipants: "Max. účastníků",
        Description: "Popis",
        State: "Stav",
      },
      RewardSuffix: "BLC",
      Types: {
        BugHunter: "Bug Hunter",
        Mentoring: "Mentoring",
        Engineering: "Engineering",
        Challenge: "Challenge",
      },
    },
    PickReward: {
      Title: "Výběr odměny",
      Description: "Popis",
      SubmitText: "Vybrat",
      Balance: "Aktuální stav",
      Quantity: {
        Limited: "Dostupné: ",
        Unlimited: "Bez omezení",
      },
    },
    CreateReward: {
      Title: "Vytvořit odměnu",
      SubmitText: "Vytvořit",
      SuccessText: "Odměna byla úspěšně vytvořena!",
      Fields: {
        Title: {
          Label: "Název",
        },
        Cost: {
          Label: "Cena",
          Suffix: "BLC",
        },
        LimitedQuantity: "Omezené množství",
        Start: "Začátek",
        TimeLimit: "Časové omezení",
        Description: {
          Label: "Popis",
        },
      },
    },
    EditReward: {
      Title: "Upravit odměnu",
      SubmitText: "Upravit",
      SuccessText: "Změny byly úspěšně uloženy",
      Fields: {
        Title: {
          Label: "Název",
        },
        Cost: {
          Label: "Cena",
          Suffix: "BLC",
        },
        LimitedQuantity: "Omezené množství",
        Start: "Začátek",
        TimeLimit: "Časové omezení",
        Description: {
          Label: "Popis",
        },
      },
    },
    DetailReward: {
      Title: "Detail odměny",
      Fields: {
        Name: "Název",
        State: "Stav",
        Cost: "Cena v coins",
        RewardSuffix: "BLC",
        Claimed: "Vybráno",
        Popularity: "Popularita",
        CanClaim: "Může vybrat",
        Quantity: "Množství",
        LimitedQuantity: "Omezené množství",
        TimeLimit: "Časové omezení",
        Created: "Vytvořeno",
        Start: "Začátek",
        Expiration: "Ukončení",
        Description: "Popis",
        NoLimit: "Bez omezení",
      },
    },
    Dashboard: {
      Title: "Přehled",
      Fields: {
        XPEarned: "Získáno XP",
        QuestsCompleted: "Splněných misí",
        ChallengesCompleted: "Zúčastněn výzev",
        ActiveFrom: "Aktivní od",
        Completed: "Splněno",
        SuffixCoins: "BLC",
      },
    },
  },
  zod: translation,
  Components: {
    RichTextToolbar: {
      Bold: "Tučné",
      Italic: "Kurzíva",
      Underline: "Podtržené",
      BulletList: "Odrážkový seznam",
      OrderedList: "Číslovaný seznam",
      DecreaseIndent: "Zmenšit odsazení",
      IncreaseIndent: "Zvětšit odsazení",
      InsertLink: "Vložit odkaz",
      Heading: "Nadpis",
      Body: "Tělo textu",
      Heading1: "Nadpis 1",
      Heading2: "Nadpis 2",
      Heading3: "Nadpis 3",
      Heading4: "Nadpis 4",
      Heading5: "Nadpis 5",
      Heading6: "Nadpis 6",
      LinkNoSelection: "Pro vložení odkazu nejprve vyberte text.",
      EnterURL: "Zadejte URL:",
    },
  },

  Tables: {
    Quests: {
      Loading: "Načítání Questů...",
      Error: "Chyba při načítání Questů!",
      NoTimeLimit: "Bez omezení",
    },
    Rewards: {
      Loading: "Načítání odměn...",
      Error: "Chyba při načítání odměn!",
      NoTimeLimit: "Bez omezení",
    },
    Players: {
      Loading: "Načítání hráčů...",
      Error: "Chyba při načítání hráčů!",
      Fields: {
        FullName: "Jméno příjmení",
        XP: "XP",
        Coins: "Coins",
        ActiveRequests: "Aktivní žádosti",
        ActiveQuests: "Aktivní mise",
        PendingApprovals: "Čekající schválení",
      },
    },
  },

  RequestCards: {
    RequestDetail: {
      Title: "Detaily žádosti",
      Fields: {
        Quest: "Quest",
        Reward: "Odměna",
        Status: "Stav",
        CreatedDate: "Datum vytvoření",
        RequestedBy: "Požádal",
        ApprovedDate: "Datum schválení",
        CompletedDate: "Datum dokončení",
      },
      Actions: {
        Approve: "Schválit",
        Reject: "Zamítnout",
        RequestSent: "Žádost zaslána",
        RequestQuest: "Zažádat o misi",
        SubmitForReview: "Odeslat k posouzení",
        ApproveCompletion: "Schválit splnění",
        RejectCompletion: "Zamítnout splnění",
      },
      StatusValues: {
        Requested: "Požádáno",
        Active: "Aktivní",
        Pending: "Čekající",
        Completed: "Splněno",
        Canceled: "Zrušeno",
        Approved: "Schváleno",
        Denied: "Zamítnuto",
      },
    },
    MissionRequests: {
      Title: "Žádosti o mise",
      EmptyState: "Žádné žádosti o mise.",
      Loading: "Načítají se žádosti o mise...",
      Error: "Nepodařilo se načíst žádosti o mise.",
    },
    RewardRequests: {
      Title: "Žádosti o odměny",
      EmptyState: "Žádné žádosti o odměny.",
      Loading: "Načítají se žádosti o odměny...",
      Error: "Nepodařilo se načíst žádosti o odměny.",
    },
    StatusColumns: {
      Requested: {
        Title: "Požádáno",
        EmptyState: "Žádné požadavky.",
        Loading: "Načítají se požadavky...",
        Error: "Nepodařilo se načíst požadavky.",
      },
      Pending: {
        Title: "Čekající",
        EmptyState: "Žádné čekající požadavky.",
        Loading: "Načítají se čekající požadavky...",
        Error: "Nepodařilo se načíst čekající požadavky.",
      },
      Completed: {
        Title: "Dokončeno",
        EmptyState: "Žádné dokončené požadavky.",
        Loading: "Načítají se dokončené požadavky...",
        Error: "Nepodařilo se načíst dokončené požadavky.",
      },
    },
    Types: {
      Quest: "Mise",
      Reward: "Odměna",
    },
    Common: {
      UnknownUser: "Neznámý uživatel",
      UnknownQuest: "Neznámá mise",
    },
    Filters: {
      All: "Vše",
      ShowAll: "Zobrazit vše",
      StatusFilter: "Filtr podle stavu",
    },
  },

  States: {
    Requested: "Žádost",
    Upcoming: "Nadcházející",
    Active: "Aktivní",
    Expired: "Ukončeno",
    Canceled: "Zrušeno",
    Archived: "Archivováno",
  },
};
